import Container from '@/components/Container';
import { Typography } from '@mui/material';
import SwitchInput from '@/components/forms/SwitchInput';
import TextInput from '@/components/forms/TextInput';
import React from 'react';

interface CustomWord {
  blockPath: string;
  tComponents: (key: string) => string;
  filterEnabled: boolean;
}

const FilterFreeTextSearch: React.FC<CustomWord> = ({ blockPath, tComponents, filterEnabled }) => (
  <Container fullWidth column right mb={2}>
    <Container fullWidth>
      <Container fullWidth left>
        <Typography variant='body1' sx={{ fontWeight: 'bold' }}>
          {tComponents('DMFilterSearch.FreeTextSearchTitleLabel')}
        </Typography>
      </Container>
      <Container fullWidth right>
        <div style={{ width: 'auto' }}>
          <SwitchInput
            path={`${blockPath}.userCanFilterFreeTextSearch`}
            label={tComponents('DMFilterSearch.UserFiltrationOnWebsite')}
          />
        </div>
      </Container>
    </Container>
    <Container fullWidth>
      <TextInput path={`${blockPath}.FreeTextSearch`} label={tComponents('DMFilterSearch.FreeTextSearch')} />
      {filterEnabled && (
        <div style={{ width: '30%' }}>
          <TextInput
            path={`${blockPath}.FreeTextSearchDropDownMenuTitle`}
            label={tComponents('DMFilterSearch.FreeTextSearchDropDownMenuTitleLabel')}
          />
        </div>
      )}
    </Container>
    <Container fullWidth>
      <TextInput
        path={`${blockPath}.AdditionalHiddenQuery`}
        label={tComponents('DMFilterSearch.AdditionalHiddenQuery')}
      />
    </Container>
  </Container>
);

export default FilterFreeTextSearch;
